<app-dialog [title]="'titles.edit-unit'|translate" [showDialogActions]="false">

  <app-unit-view-form appDialogContent class="width-100-percent"
                      [unit]="data.unit"
                      [isDialogContext]="true">
  </app-unit-view-form>

</app-dialog>
